export default __webpack_public_path__ + "static/media/acar_preview.30bbdfb2.png";